import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'doctor_checkups'

const answers: AnswerType[] = [
  {
    emoji: '🚫‍',
    title: 'pages.onboarding.doctorCheckups.options.rarely',
    value: 'rarely',
  },
  {
    emoji: '⏳',
    title: 'pages.onboarding.doctorCheckups.options.everyFewYears',
    value: 'every-few-years',
  },
  {
    emoji: '📅',
    title: 'pages.onboarding.doctorCheckups.options.every2To3Years',
    value: 'every-2-3-years',
  },
  {
    emoji: '✅',
    title: 'pages.onboarding.doctorCheckups.options.yearly',
    value: 'yearly',
  },
]

export default function DoctorCheckupsPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How often do you have health checkups?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.doctorCheckups.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
